"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTAINER_RESERVED_KEYS = exports.ROW_RESERVED_KEYS = exports.COLUMN_RESERVED_KEYS = exports.BASE_RESERVED_KEYS = void 0;
var BASE_RESERVED_KEYS = ['breakpoints', 'rootSize', 'columns'];
exports.BASE_RESERVED_KEYS = BASE_RESERVED_KEYS;
var COLUMN_RESERVED_KEYS = ['size', 'gap', 'padding'];
exports.COLUMN_RESERVED_KEYS = COLUMN_RESERVED_KEYS;
var ROW_RESERVED_KEYS = COLUMN_RESERVED_KEYS.concat(['gutter', 'colCss', 'colComponent']);
exports.ROW_RESERVED_KEYS = ROW_RESERVED_KEYS;
var CONTAINER_RESERVED_KEYS = ROW_RESERVED_KEYS.concat(['rowCss', 'rowComponent']);
exports.CONTAINER_RESERVED_KEYS = CONTAINER_RESERVED_KEYS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/constants.js
// module id = 63
// module chunks = 0